<template>
<div>
    <div class="print-wrap" id="printPage">
        <h2 class="print-title">{{info.orgName}}收款依据</h2>
        <div class="print-time">{{info.printDate}}</div>
        <div class="print-content">
          <div class="print-content-item">
            <div class="print-content-item-title">今收到客户</div>
            <div class="print-content-item-solt">{{info.customerName}}</div>
          </div>
          <div class="print-content-item">
            <div class="print-content-item-title">交来</div>
            <div class="print-content-item-solt">{{info.payTypeCnName}}</div>
          </div>
          <div class="print-content-item">
            <div class="print-content-item-title">金额</div>
            <div class="print-content-item-solt">{{info.amountCnName}}  (￥{{info.amount}})</div>
          </div>
        </div>
        <div class="print-foot">
          <div class="print-foot-item">单位主管</div>
          <div class="print-foot-item">交款人</div>
          <div class="print-foot-item">收款人&nbsp;&nbsp;{{info.settlementPerson}}</div>
          <div class="print-foot-item">开单人&nbsp;&nbsp;{{info.loginPerson}}</div>
        </div>
    </div>
    <div class="dialog-footer">
      <el-button type="primary" @click="handlePrint">打 印</el-button>
    </div>
</div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'printDialog',
  data () {
    return {
      info: {}
    }
  },
  computed: {
    getId () {
      return this.$route.query.id
    }
  },
  methods: {
    ...mapActions(['getPrintInfo']),
    handlePrint () {
      window.print()
    }
  },
  mounted () {
    this.getPrintInfo({ id: this.getId }).then(res => {
      this.info = res
    })
  }
}
</script>

<style lang="scss" scoped>
@media print {
  body{
    margin: 0;
    padding: 0;
  }
  .dialog-footer{
    display: none;
  }
}
@page {
  size:A5 landscape;
}
.formItem{
  text-align: center;
}
.el-form-item{
  margin-left: 0;
}
.print-content{
  padding: 10px;
  margin-top: 10px;
  height: 140px;
  border: 2px solid #000;
  font-size: 14px;
  .print-content-item{
    display: flex;
    height: 40px;
    line-height: 40px;
  }
  .print-content-item-title{
    width: 100px;
    padding: 0 15px;
    text-align: right;
  }
  .print-content-item-solt{
    flex: auto;
    font-weight: bold;
  }
}
.dialog-footer{
  margin-top: 80px;
  text-align: center;
}
.print-wrap{
  margin: 20px auto;
  width: 600px;
  .print-time{
    text-align: center;
  }
  .print-title{
    margin: 0;
    padding: 0;
    text-align: center;
    font-size: 20px;
  }
  .print-foot{
    margin-top: 15px;
    display: flex;
    .print-foot-item{
      flex: 1;
    }
  }
}
</style>
